const HEAP_SCRIPT_ID = "reactjs-heap";

declare global {
  interface Window {
    heap?: {
      identify?: (identity: string) => void;
      addUserProperties?: (properties: Record<string, unknown>) => void;
    };
  }
}

export class HeapManager {
  private static getHeapScript = (id: string | number) => `
  window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
  heap.load("${id}");
`;

  initializeHeap = (id: string | number) => {
    if (!id) {
      throw new Error("You need to provide your Heap Analytics ID.");
    }

    if (!document) {
      return;
    }

    const hasScript = !!document.getElementById(HEAP_SCRIPT_ID);
    if (hasScript) {
      return;
    }

    const script = document.createElement("script");
    script.innerHTML = HeapManager.getHeapScript(id);
    script.id = HEAP_SCRIPT_ID;
    script.async = true;
    document.body.appendChild(script);
  };

  setIdentity = (userId: string, email: string, currentOrgId: string) => {
    if (window.heap?.identify && window.heap?.addUserProperties) {
      window.heap.identify(userId);
      window.heap.addUserProperties({
        userId,
        userGuid: userId,
        email,
        organisationId: currentOrgId,
      });
    }
  };
}
